import ChargerModule from 'components/chargerModule';
import QuoteDetailsModule from './components/QuoteDetailsModule/QuoteDetailsModule';
import { Breadcrumbs } from 'components/BreadCrumbs/BreadCrumbs';
import { useParams } from 'react-router-dom';
import './QuoteDetails.scss';

const QuoteDetails = () => {
  const HEADER_INFO = { title: 'Cotizaciones', subtitle: 'Detalle de cotización' };
  const { id } = useParams<{ id: string }>();

  return (
    <ChargerModule
      headerInfo={HEADER_INFO}
      infoSideBar={{ position: 'quote' }}
      customHeading={
        <Breadcrumbs
          items={[
            { href: '/quote/list', label: 'Cotizaciones', goBack: true },
            { href: `/quote/details/${id}`, label: 'Detalle de cotización' }
          ]}
        />
      }
    >
      <QuoteDetailsModule />
    </ChargerModule>
  );
};

export default QuoteDetails;
